export default __webpack_public_path__ + "static/media/snow_man.70b336bc.png";